import ButtonCommon from 'components/common/ButtonCommon';
import { DESKTOP_MIN_WIDTH } from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

const ETAIframePopup = ({
  isOpen,
  onClose,
  onClick,
  modalStyles,
  modalOptions,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();
  const { iframeSrc } = modalOptions || {};

  return (
    <>
      <style>
        {zIndexModal
          ? `
            .modal {
              z-index: ${zIndexModal || 1101};
            }
        `
          : ``}
        {isBackdropOverlap
          ? `
          .eta-iframe-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || 1100}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .eta-iframe-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={onClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="eta-iframe-modal-backdrop"
        centered
        $styles={modalStyles}
      >
        <IframeStyled
          id="eta-iframe"
          src={iframeSrc}
          $styles={modalStyles}
          frameborder="0"
          scrolling="yes"
          loading="lazy"
        />
        <ButtonWrap>
          <ButtonCommon
            color="var(--c-primary)"
            background="var(--bg-primary)"
            value={t('button_close')}
            styles={{
              border: 'none',
              width: isDesktop ? '200px' : '50%',
              minHeight: '40px',
            }}
            onClick={onClose}
            isFill={true}
          />
        </ButtonWrap>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 0px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      margin-inline: auto;
      border: none;
      width: calc(100dvw - 32px);
      border-radius: ${(props) => props.$styles?.borderRadius}px!important;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      max-width: fit-content;
      & .modal-content {
        width: ${(props) => props.$styles?.width}px;
      }
    }
  }
`;

const IframeStyled = styled.iframe`
  width: 100%;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  height: fit-content;
  min-height: 460px;
  max-height: 80dvh;
  border-radius: ${(props) => props.$styles?.borderRadius}px!important;
  padding: 16px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    min-height: 490px;
    max-height: 80dvh;
  }
`;

const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 72px;
  width: 100%;
  background: #fff;
  position: sticky;
  bottom: 0px;
  border-radius: 0px 0px 12px 12px;
`;

export default ETAIframePopup;
